import { WorkflowActivityUrl } from '../models/workflowActivity';
import { workflowActivitySchema } from '../models/workflowActivity.schema';

export const get = (workflowActivityUrl: WorkflowActivityUrl) => {
  return {
    endpoint: workflowActivityUrl,
    method: 'GET',
    responseSchema: workflowActivitySchema,
  } as const;
};
